import React from 'react';
import SubTitle from '../components/SubTitle'

const NewsItem = ({item}) => {
	const created = new Date(item.Created);
	return (
		<div className="news-item">
			<div className="news-item-time">
				<div className="news-item-month">{created.getMonth().toString().length < 2? "0" : ""}{created.getMonth() + 1}</div>
				<div className="news-item-date">{created.getDate().toString().length < 2? "0" : ""}{created.getDate() + 1}</div>
			</div>
			<div className="news-item-content">
				<h3><a className="" href={`#/newsdetail/${item.ID}`} target="_blank">{item.Title}</a></h3>
				<p className="">{`${item.PlainText.substr(0, 100)}...`}</p>
			</div>
		</div>
	)
}


const News = ({items, newsType}) => {
	let title = "公司新闻";
	let subTitle = "NEWS";

	if(newsType === "Enterprise"){
		title = "企业新闻";
		subTitle = "Corporate news";
	}
	if(newsType === "Industry"){
		title = "行业动态";
		subTitle = "Industry dynamic";
	}
	return (
		<div className="block-content">
			<SubTitle title={title} subTitle={subTitle} />
	      	<div className="news">
	      		{
	                items && items.map((n, i) => {
	                      return(<NewsItem key={i} item={n} />);
	                })
	            }
	      	</div>
		</div>
	);
}

export default News;


// WEBPACK FOOTER //
// ./src/components/News.js